import React from "react";
import Slider from "react-slick";
import "./plan.css";
import dollar from "../../asset/dollar.svg";
import dollarsilver from "../../asset/dollarsilver.svg";
import dollarbasic from "../../asset/dollarbasic.svg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Plan = () => {
  // Slider settings
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3, // Show 3 plans at a time on desktop
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000, // Change slides every 3 seconds
    responsive: [
      {
        breakpoint: 768, // For tablets
        settings: {
          slidesToShow: 1, // Keep it one slide
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024, // For tablets
        settings: {
          slidesToShow: 2, // Show 2 plans at a time
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, // For mobile phones
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="planContainer">
      <div className="planHead">
        <div className="planHeadOne">
          <h2>INVESTMENT</h2>
          <h1>PLANS</h1>
        </div>
        <div className="planHeadTwo">
          <p>
            BNBCryptoInvestment provides profitable cryptocurrency investment.
            Customers can choose different investment plans for rewarding asset
            management. Our customers can earn passive income without any
            trading knowledge.
          </p>
        </div>
      </div>

      {/* Slider */}
      <Slider {...settings} className="planSlider">
        {/* Basic Plan */}
        <div className="planItem">
          <h3>
            Basic <img src={dollarbasic} alt="Basic Plan Icon" />
          </h3>
          <p className="percent">10%</p>
          <p>Minimum - $100</p>
          <p>Maximum - Unlimited</p>
          <p>Plan Duration: 24 hours</p>
          <p>Capital Included</p>
          <a href="/Signup">
            <button className="planButton">INVEST NOW</button>
          </a>
        </div>

        {/* Silver Plan */}
        <div className="planItem">
          <h3>
            Silver <img src={dollarsilver} alt="Silver Plan Icon" />
          </h3>
          <p className="percent">15%</p>
          <p>Minimum - $1,000</p>
          <p>Maximum - Unlimited</p>
          <p>Plan Duration: 48 hours</p>
          <p>Capital Included</p>
          <a href="/Signup">
            <button className="planButton">INVEST NOW</button>
          </a>
        </div>

        {/* Gold Plan */}
        <div className="planItem">
          <h3>
            Gold <img src={dollar} alt="Gold Plan Icon" />
          </h3>
          <p className="percent">20%</p>
          <p>Minimum - $5,000</p>
          <p>Maximum - Unlimited</p>
          <p>Plan Duration: 3 days</p>
          <p>Capital Included</p>
          <a href="/Signup">
            <button className="planButton">INVEST NOW</button>
          </a>
        </div>

        {/* Platinum Plan */}
        <div className="planItem">
          <h3>
            Platinum <img src={dollar} alt="Platinum Plan Icon" />
          </h3>
          <p className="percent">30%</p>
          <p>Minimum - $10,000</p>
          <p>Maximum - Unlimited</p>
          <p>Plan Duration: 1 week</p>
          <p>Capital Included</p>
          <a href="/Signup">
            <button className="planButton">INVEST NOW</button>
          </a>
        </div>
      </Slider>
    </div>
  );
};

export default Plan;
